import React from "react";
import { useForm, FormProvider } from "react-hook-form";
// import { useQuery } from "@tanstack/react-query";
// import { post } from "@utils/axios_api";
import { Select, Input } from "@components/form";
// import { getOptions } from '@utils/CommonCodes';

function InstructorSearch({ defaultValues, onSearch, onReset }) {

  const methods = useForm({
    defaultValues,
  });
  const { handleSubmit, reset } = methods;

  const handleReset = () => {
    if (!window.confirm('조회 조건을 초기화 하시겠습니까?')) return;  
    reset({
      outYn   : "",
      searchCnd  : "",
      searchWrd  : "",
    });
    onReset && onReset();
  };


  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSearch)}>
        <div className="search-wrap">
          <div className="search-row">
          <div className="search-item">
            <label>외부여부</label>
            <Select
              name="outYn"
              options={[
                { key: "",  name: "전체" },
                { key: "Y", name: "외부" },
                { key: "N", name: "내부" },
              ]}
              defaultOption={false}
              className="input-select"
            />

            <label style={{ marginLeft: "10px" }}>조회조건</label>

              <Select
                name="searchCnd"
                options={[
                  { key: "0", name: "이름" },
                ]}
                defaultOption="선택"
                className="input-select"
              />
              <Input
                name="searchWrd"
                placeholder="검색어를 입력하세요"
                className="input-search"
                style={{ width: "250px" }}
              />
            </div>

            <div className="search-btn-container">
              <button type="submit" className="btn-search">조회</button>
              <button type="button" className="btn-reset" onClick={handleReset}>초기화</button>
            </div>
          </div>
        </div>
      </form>
    </FormProvider>
  );
}

export default InstructorSearch;
